import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loader" }, [
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div")
    ], -1)),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}